module.exports = __webpack_public_path__ + "static/media/2cb1c644-8c1e-4493-aaac-904d426ad38e.d02f6b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/2cb1c644-8c1e-4493-aaac-904d426ad38e.png
// module id = 1482
// module chunks = 0